exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-container {\n\tpadding:0 0 20px 0;\n\tmargin: 0px;\n\tmin-height: 100vh;\n\tborder-radius: 0px;\n}\n.address-form-title{\n    font-weight: 500;\n    font-size: 22px;\n}\n.form-container .btn-flat i {\n\tline-height: 1.4;\n\tfont-size: 24px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/client-address-form/client-address-form.component.css
// module id = ../../../../../src/app/mnt-invoices/client-address-form/client-address-form.component.css
// module chunks = common